import { type CreditCardItem } from '@webapp/modules/accounts-payable/entities/CreditCardItem'
import { useInlineEditCreditCardItemPresenter } from './useInlineEditCreditCardItemPresenter'
import { InlineItemCostCell } from '../../views/InlineItemCostCell'

export interface IInlineEditCreditCardItemPresenterProps {
  /** Slot-rendered into the CC pane via renderInlineCostCell (ADR-9) */
  item: CreditCardItem
  /** FS clears the suggested filter; invalidation refetches both panes (BHV-038) */
  onSaved: () => void
}

export const InlineEditCreditCardItemPresenter = ({
  item,
  onSaved,
}: IInlineEditCreditCardItemPresenterProps) => {
  const {
    data: { inputValue, status },
    methods: { onInputChange, onInputBlur, onInputKeyDown, onCurrencyChange },
  } = useInlineEditCreditCardItemPresenter({ item, onSaved })

  return (
    <InlineItemCostCell
      item={item}
      inputValue={inputValue}
      status={status}
      onInputChange={onInputChange}
      onInputBlur={onInputBlur}
      onInputKeyDown={onInputKeyDown}
      onCurrencyChange={onCurrencyChange}
    />
  )
}

InlineEditCreditCardItemPresenter.displayName =
  'InlineEditCreditCardItemPresenter'
